import { ACTION_STATUSES } from 'constants/actionTracker';
import { checkIsDeadlinePassed } from 'helper/DateLib';

export const getDeadlineChipColor = (status, dateValue) => {
  if (status === ACTION_STATUSES.COMPLETED) {
    return 'success';
  }

  if (checkIsDeadlinePassed(dateValue)) {
    return 'error';
  }

  return 'default';
};
